<div class="main-layout-bg">
    <div class="main-layout-panel">
        <header class="flex justify-between items-center px-6 py-4">
            <a routerLink="/" class="brand">
                <span class="brand-blocks" aria-hidden="true">
                    <span class="brand-block b1"></span>
                    <span class="brand-block b2"></span>
                    <span class="brand-block b3"></span>
                </span>
                <h1 class="brand-title">SNK</h1>
            </a>
            @if (roomInfo(); as room) {
            <div class="chrome-center">
            <div class="chrome-frame">
            <div class="room-chrome">
                <div class="room-chrome-name">
                    @if (room.hasPassword) {
                    <span class="room-chrome-private" title="Private Room">PRIVATE</span>
                    }
                    <span class="room-chrome-title">{{ room.roomName }}</span>
                    <span class="room-chrome-count">{{ room.playerCount }}/{{ room.maxPlayers }}</span>
                </div>
                <div class="room-chrome-code">
                    <span class="room-chrome-code-text">{{ room.joinCode }}</span>
                    <button
                        class="room-chrome-copy"
                        (click)="copyRoomLink()"
                        aria-label="Copy room link"
                    >
                        COPY
                    </button>
                </div>
            </div>
            </div>
            <span class="leave-frame">
                <button class="header-leave" (click)="requestLeave()">⏻ LEAVE</button>
            </span>
            </div>
            }
            <div class="header-right">
                <snk-sound-control [inRoom]="isRoomRoute()" />
                @if (username(); as name) {
                <a
                    class="header-username"
                    routerLink="/welcome"
                    [queryParams]="{ edit: 1 }"
                    title="Change your name"
                >{{ name }}</a>
                }
            </div>
        </header>
        <main>
            <router-outlet></router-outlet>
        </main>
        <footer class="py-4">
            <div class="px-4 text-center">
                @if (isRoomRoute()) {
                <p class="controls-hint">◄ ► ▲ ▼ MOVE · SPACE ATTACK · 1-3 TARGET · Q SWAP · E USE · M MUTE</p>
                } @else {
                <p>&copy; 2026 SNK. All rights reserved.</p>
                }
            </div>
            <span [class]="'status-pill ' + (connectionStatus().connected ? 'status-connected' : connectionStatus().connecting ? 'status-connecting' : 'status-disconnected')">
              <span class="status-dot" aria-hidden="true"></span>
              <span class="status-label">{{ connectionStatus().connected ? 'Connected' : connectionStatus().connecting ? 'Connecting...' : 'Disconnected' }}</span>
            </span>
        </footer>
    </div>
</div>
@if (sessionConflict(); as kind) {
<snk-session-conflict
    [kind]="kind"
    [onLobby]="isLobbyRoute()"
    [busy]="takingOver()"
    (playHere)="playHere()"
    (backToLobby)="backToLobby()"
/>
}
